import { ApiProperty } from "@nestjs/swagger";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { PackingMaterialPricesEntity } from "./packing-material-prices-entity";


@Entity('pack_material_price_log')
export class PackingMaterialPricesLogs{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;

    
  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: false,
    name: "price"
  })
  price: number;
   
  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

  @Column({
    name: "effective_from",
    type: 'datetime'
  })
  effectiveFrom: Date;

 
  // @Column("enum", {
  //   nullable: false,
  //   name: "category",
  //   enum:FgPriceListCategoryEnum
  // })
  // category: FgPriceListCategoryEnum;

  // @Column('int',{
  //   nullable: true,
  //   name: "fg_pricelist_id"
  // })
  // FgpriceListId: number;
   

  // @ManyToOne(type=>Product, e=>e.fgPriceInfo,{  nullable:false, })
  //   @JoinColumn({ name:"product_id"})
  //   productId: Product;

    @ManyToOne(type=>PackingMaterialPricesEntity, e=>e.packingMaterialInfo,{ nullable:false, })
    @JoinColumn({ name:"pack_material_prices_id"})
    PackingMaterialPricesId: PackingMaterialPricesEntity;

}